"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReseller = void 0;
const react_query_1 = require("@tanstack/react-query");
const query_1 = require("../../providers/query");
const services_1 = require("../../services");
const helpers_1 = require("../../utils/helpers");
class BarrilUseResellerError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BarrilUseResellerError';
    }
}
const useReseller = (params, enabled = true) => {
    const queryResult = (0, react_query_1.useQuery)({
        queryKey: ['reseller', params],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if ('resellerSlug' in params && (0, helpers_1.isGenericReseller)(params.resellerSlug)) {
                    return null;
                }
                return yield (0, services_1.getReseller)(Object.assign({}, params));
            }
            catch (err) {
                window.NREUM.noticeError(new BarrilUseResellerError(`Error fetching reseller: ${err instanceof Error ? err.message : err}`), {
                    customAttributes: {
                        params,
                        error: err instanceof Error ? err.message : String(err),
                    },
                    customError: true,
                });
                throw err;
            }
        }),
        context: query_1.BarrilQueryClientContext,
        enabled,
    });
    return {
        reseller: queryResult.data,
        idle: !queryResult.isLoading && !queryResult.isError && !queryResult.data,
        resolved: queryResult.isSuccess,
        error: queryResult.error,
        loading: queryResult.isLoading,
    };
};
exports.useReseller = useReseller;
